export const doubleToCurrency = (value) => {
	const euro = new Intl.NumberFormat('de-DE', {
		style: 'currency',
		currency: 'EUR',
	})

	if (!value || value == 0.0) {
		return '-'
	}
	return euro.format(value)
}
